/**
 * Auth feature constants.
 */

// ─── RPCs ──────────────────────────────────────────────────────────────────

/**
 * Returns whether the caller has a row in `admins`.
 *
 * Must be called as an RPC, **not** queried as a table: `admins` has RLS
 * enabled with **no policies at all**, so `from('admins').select(...)` returns
 * an empty set for every caller, including real admins. `is_admin()` is
 * `SECURITY DEFINER`, so it bypasses that — and it is the same function every
 * "Admin full access" policy uses, which is what keeps the UI's idea of a
 * teacher and the database's idea of one from drifting apart.
 *
 * Defined in `supabase/migrations/00000000000000_baseline.sql`.
 */
export const IS_ADMIN_RPC = 'is_admin' as const;

/**
 * Returns the caller's application context in one row:
 * `{ role, teacher_id, subscription_status }`. Replaces the `is_admin()` call
 * in `fetchUserProfile()` — one round-trip now yields role precedence
 * (super_admin → teacher → student → incomplete_student), the tenant id, and
 * the owning teacher's subscription state.
 *
 * `SECURITY DEFINER`, defined in the Phase 3 multi-tenant migration.
 */
export const GET_MY_CONTEXT_RPC = 'get_my_context' as const;

/**
 * Resolves a browser hostname to its owning `teacher_id`, or `null` for an
 * unknown/lapsed domain. Anon-callable, because registration runs before the
 * user is authenticated. Takes `{ p_domain }`.
 *
 * `SECURITY DEFINER`, defined in the Phase 3 multi-tenant migration.
 */
export const GET_TEACHER_ID_BY_DOMAIN_RPC = 'get_teacher_id_by_domain' as const;
